(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  class KsTestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;
      this.startPos = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationId = 0;
      this.autoplayInterval = null;
      this.slideWidth = 0;
      this.slidesPerView = this.calculateSlidesPerView();

      // Initialize after a slight delay to ensure DOM is ready
      setTimeout(() => {
        this.setupSlider();
        this.setupEventListeners();
        this.updateSlider();

        if (this.dataset.sliderAutoplay !== '0') {
          this.startAutoplay();
        }
      }, 50);
    }

    calculateSlidesPerView() {
      const width = window.innerWidth;
      if (width < 576) return parseInt(this.dataset.breakpointXs);
      if (width < 768) return parseInt(this.dataset.breakpointSm);
      if (width < 992) return parseInt(this.dataset.breakpointMd);
      if (width < 1200) return parseInt(this.dataset.breakpointLg);
      if (width < 1400) return parseInt(this.dataset.breakpointXl);
      return parseInt(this.dataset.breakpointXxl);
    }

    setupSlider() {
      this.sliderWrapper = this.querySelector('.slider-wrapper');
      this.sliderTrack = this.querySelector('.slider-track');
      this.slides = Array.from(this.querySelectorAll('.slider-slide'));
      this.prevButton = this.querySelector('.slider-button-prev');
      this.nextButton = this.querySelector('.slider-button-next');
      this.dotsContainer = this.querySelector('.slider-dots');
      this.scrollbar = this.querySelector('.slider-scrollbar');
      this.scrollbarThumb = this.querySelector('.slider-scrollbar-thumb');

      // Initialize dots if pagination is enabled
      if (this.dataset.sliderPagination === 'true' && this.dotsContainer) {
        this.slides.forEach((_, index) => {
          const dot = document.createElement('div');
          dot.classList.add('slider-dot');
          if (index === 0) dot.classList.add('active');
          dot.addEventListener('click', () => this.goToSlide(index));
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          this.dotsContainer.appendChild(dot);
        });
      }

      // Initialize scrollbar if enabled
      if (this.dataset.sliderScrollbar === 'true' && this.scrollbarThumb) {
        this.updateScrollbar();
      }
    }

    setupEventListeners() {
      // Navigation buttons
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prevSlide());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.nextSlide());
      }

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });

      // Touch events for mobile swipe
      this.sliderTrack.addEventListener('touchstart', this.touchStart.bind(this), { passive: false });
      this.sliderTrack.addEventListener('touchend', this.touchEnd.bind(this), { passive: true });
      this.sliderTrack.addEventListener('touchmove', this.touchMove.bind(this), { passive: false });

      // Mouse events for desktop drag
      this.sliderTrack.addEventListener('mousedown', this.touchStart.bind(this));
      this.sliderTrack.addEventListener('mouseup', this.touchEnd.bind(this));
      this.sliderTrack.addEventListener('mouseleave', this.touchEnd.bind(this));
      this.sliderTrack.addEventListener('mousemove', this.touchMove.bind(this));

      // Window resize
      window.addEventListener('resize', () => {
        this.slidesPerView = this.calculateSlidesPerView();
        this.updateSlider();
      });
    }

    touchStart(e) {
      if (e.type === 'mousedown') {
        this.isDragging = true;
        this.startPos = e.clientX;
        e.preventDefault(); // Prevent text selection
      } else {
        this.startPos = e.touches[0].clientX;
      }

      this.prevTranslate = this.currentTranslate;
      this.sliderTrack.style.transition = 'none';

      // Cancel any ongoing animation
      cancelAnimationFrame(this.animationId);

      // Pause autoplay while dragging
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
    }

    touchEnd() {
      this.isDragging = false;
      const movedBy = this.currentTranslate - this.prevTranslate;

      if (movedBy < -50 && this.currentIndex < this.slides.length - this.slidesPerView) {
        this.nextSlide();
      } else if (movedBy > 50 && this.currentIndex > 0) {
        this.prevSlide();
      } else {
        this.goToSlide(this.currentIndex);
      }

      // Resume autoplay if enabled
      if (this.dataset.sliderAutoplay !== '0') {
        this.startAutoplay();
      }
    }

    touchMove(e) {
      if ((e.type === 'mousemove' && !this.isDragging) || (e.type === 'touchmove' && !this.startPos)) return;

      if (e.cancelable) e.preventDefault();
      const currentPosition = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const diff = currentPosition - this.startPos;
      this.currentTranslate = this.prevTranslate + diff;

      this.sliderTrack.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    updateSlider() {
      if (!this.sliderTrack || this.slides.length === 0) return;

      // Calculate slide width based on container width and slides per view
      const containerWidth = this.sliderWrapper.clientWidth;
      this.slideWidth = containerWidth / this.slidesPerView;

      // Set slide widths
      this.slides.forEach((slide) => {
        slide.style.width = `${this.slideWidth}px`;
      });

      // Set track width
      this.sliderTrack.style.width = `${this.slideWidth * this.slides.length}px`;

      // Update position
      this.goToSlide(this.currentIndex);
    }

    goToSlide(index) {
      // Ensure index is within bounds
      this.currentIndex = Math.max(0, Math.min(index, this.slides.length - this.slidesPerView));

      // Calculate new position
      const newPosition = -this.currentIndex * this.slideWidth;
      this.currentTranslate = newPosition;

      // Apply transition and transform
      this.sliderTrack.style.transition = `transform ${this.dataset.sliderSpeed}ms ease-out`;
      this.sliderTrack.style.transform = `translateX(${newPosition}px)`;

      // Update active classes
      this.updateActiveState();

      // Update scrollbar
      this.updateScrollbar();

      // Focus management for accessibility
      this.slides[this.currentIndex].setAttribute('tabindex', '0');
      this.slides[this.currentIndex].focus({ preventScroll: true });
    }

    nextSlide() {
      if (this.currentIndex < this.slides.length - this.slidesPerView) {
        this.goToSlide(this.currentIndex + 1);
      } else if (this.dataset.sliderRewind === 'true') {
        this.goToSlide(0);
      }
    }

    prevSlide() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      } else if (this.dataset.sliderRewind === 'true') {
        this.goToSlide(this.slides.length - this.slidesPerView);
      }
    }

    updateActiveState() {
      // Update slide active states
      this.slides.forEach((slide, index) => {
        slide.setAttribute('tabindex', '-1');
        if (index >= this.currentIndex && index < this.currentIndex + this.slidesPerView) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });

      // Update dots
      if (this.dotsContainer) {
        const dots = this.dotsContainer.querySelectorAll('.slider-dot');
        dots.forEach((dot, index) => {
          if (index === this.currentIndex) {
            dot.classList.add('active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('active');
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    updateScrollbar() {
      if (!this.scrollbarThumb) return;

      const totalWidth = this.slideWidth * this.slides.length;
      const visibleWidth = this.sliderWrapper.clientWidth;
      const thumbWidth = (visibleWidth / totalWidth) * 100;
      const thumbPosition = (-this.currentTranslate / totalWidth) * 100;

      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(${thumbPosition}%)`;
    }

    startAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }

      const interval = parseInt(this.dataset.sliderAutoplay) * 1000;
      if (interval > 0) {
        this.autoplayInterval = setInterval(() => {
          this.nextSlide();
        }, interval);
      }
    }

    connectedCallback() {
      // Initialize when added to DOM
      this.updateSlider();
    }

    disconnectedCallback() {
      // Clean up when removed from DOM
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }

      // Remove event listeners
      if (this.prevButton) this.prevButton.removeEventListener('click', this.prevSlide);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.nextSlide);
      this.sliderTrack.removeEventListener('touchstart', this.touchStart);
      this.sliderTrack.removeEventListener('touchend', this.touchEnd);
      this.sliderTrack.removeEventListener('touchmove', this.touchMove);
      this.sliderTrack.removeEventListener('mousedown', this.touchStart);
      this.sliderTrack.removeEventListener('mouseup', this.touchEnd);
      this.sliderTrack.removeEventListener('mouseleave', this.touchEnd);
      this.sliderTrack.removeEventListener('mousemove', this.touchMove);
      window.removeEventListener('resize', this.updateSlider);
    }
  }

  // Register the custom element
  if (!customElements.get('bse-testimonials-slider')) {
    customElements.define('bse-testimonials-slider', KsTestimonialsSlider);
  }

  // Initialize sliders when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('bse-testimonials-slider').forEach((slider) => {
      new KsTestimonialsSlider(slider);
    });
  });

  // Initialize sliders added dynamically (e.g., via theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const sliders = event.target.querySelectorAll('bse-testimonials-slider');
      sliders.forEach((slider) => {
        new KsTestimonialsSlider(slider);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
